import constantURL from "./ConstantURL";
import { getDataAPI } from "./index";

export const PROFILE_ROLE_FAMILY_MEMBER = "FAMILYMEMBER";
export const PROFILE_ROLE_CAREGIVER = "CAREGIVER";

export const getProfileDetails = async ({ emailId, role }) => {
  const normalizedEmail = String(emailId || "").trim();
  const normalizedRole = String(role || "")
    .trim()
    .toUpperCase();

  if (!normalizedEmail) {
    return { success: false, message: "Email is required.", data: null };
  }

  if (!normalizedRole) {
    return { success: false, message: "Role is required.", data: null };
  }

  try {
    const query = new URLSearchParams({
      emailId: normalizedEmail,
      role: normalizedRole,
    });
    const response = await getDataAPI(`${constantURL.authGetProfileDetails}?${query.toString()}`);

    if (!response) {
      return { success: false, message: "Unexpected server response.", data: null };
    }

    if (response.status === "success" && response.data) {
      return {
        success: true,
        message: response.message || "Profile details fetched successfully.",
        data: response.data,
      };
    }

    return {
      success: false,
      message: response.message || "Failed to fetch profile details.",
      data: null,
    };
  } catch {
    return { success: false, message: "Unable to reach the server. Please try again.", data: null };
  }
};

export const getVerificationStatus = async ({ emailId, role }) => {
  // Temporarily disabled — re-enable verification status API later.
  return { success: false, message: "", data: null };

  /*
  const normalizedEmail = String(emailId || "").trim();
  const normalizedRole = String(role || "")
    .trim()
    .toUpperCase();

  if (!normalizedEmail) {
    return { success: false, message: "Email is required.", data: null };
  }

  if (!normalizedRole) {
    return { success: false, message: "Role is required.", data: null };
  }

  try {
    const query = new URLSearchParams({
      emailId: normalizedEmail,
      role: normalizedRole,
    });
    const response = await getDataAPI(`${constantURL.authGetVerificationStatus}?${query.toString()}`);

    if (!response) {
      return { success: false, message: "Unexpected server response.", data: null };
    }

    if (response.status === "success" && response.data) {
      return {
        success: true,
        message: response.message || "Verification status fetched successfully.",
        data: {
          isEmailVerified: Boolean(response.data.isEmailVerified),
          isMobileVerified: Boolean(response.data.isMobileVerified),
        },
      };
    }

    return {
      success: false,
      message: response.message || "Failed to fetch verification status.",
      data: null,
    };
  } catch {
    return { success: false, message: "Unable to reach the server. Please try again.", data: null };
  }
  */
};
